import Axios from 'axios';
import { clearChats, getChats } from '../Actions/ChatAction';
import Apis from '../../config/Apis';
import { headers } from '../../utills';
import { showAlert } from '../Actions/GeneralActions';


export const ChatMiddleware = {

    // getInboxData: params => {
    //     return dispatch => {
    //         return new Promise(async (resolve, reject) => {
    //             try {
    //                 if (params?.next_page_url == undefined) {
    //                     dispatch(clearChatHeads());
    //                 }
    //                 const data = await Axios.get(Apis.chat_list(params?.next_page_url), await getHeaders())
    //                 if (data?.status == 200) {
    //                     if (data?.data?.data?.data) {
    //                         dispatch(getChatHeads(data?.data?.data))
    //                     }
    //                     resolve(true)
    //                 }
    //             } catch (error) {
    //                 reject(error);
    //                 dispatch(
    //                     showAlert({
    //                         title: 'Get Inbox Data',
    //                         message: error?.response?.data?.message ? error?.response?.data?.message : error?.message,
    //                         type: 'Error',
    //                         status: error?.response?.status,
    //                     }),
    //                 );
    //             }

    //         })
    //     }
    // },

    getChatMessages: ({ url }) => {
        return dispatch => {
            return new Promise(async (resolve, reject) => {
                try {
                    if (url == undefined) {
                        dispatch(clearChats());
                    }

                    const data = await Axios.get(
                        Apis.getMessages(url),
                        headers.config(),
                    );
                    if (data?.status == 200) {
                        resolve(true);

                        if (data?.data?.data?.data) {
                            dispatch(getChats(data?.data?.data));
                        }

                    }
                } catch (error) {
                    // reject(error);
                    dispatch(
                        showAlert({
                            title: 'getChatMessages',
                            message: error?.response?.data?.message ? error?.response?.data?.message : error?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                }
            });
        };
    },

    sendMessage: ({ type, message }) => {
        return dispatch => {
            return new Promise(async (resolve, reject) => {
                try {

                    let formData = new FormData()
                    formData.append('type', type)

                    if (type == 'voice') {
                        const uri = message;
                        const fileName = uri.split('/').pop();

                        const file = {
                            uri: uri,
                            name: fileName,
                            type: 'audio/mp3',
                        };

                        formData.append('message', file);
                    } else {
                        formData.append('message', message)
                    }

                    const data = await Axios.post(Apis.send_message, formData, headers.config(),)

                    if (data?.status == 200) {
                        resolve(true)
                    }
                } catch (error) {
                    if (type == 'voice') {
                        dispatch(showAlert({ message: "Couldn't send voice at the moment, please try again!" }))
                    }
                    dispatch(
                        showAlert({
                            message: error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong!',
                        }),
                    );
                }
            })
        }
    },

    // createChatList: ({ id }) => {
    //     return dispatch => {
    //         dispatch(showLoading())
    //         return new Promise(async (resolve, reject) => {
    //             try {
    //                 let formData = new FormData()
    //                 formData.append('receiver_id', id)

    //                 const data = await Axios.post(Apis.create_chat_list, formData, await getHeaders())

    //                 if (data?.status == 200) {
    //                     resolve(data?.data?.data)
    //                 }
    //             } catch (error) {
    //                 reject(error);
    //                 console.log(error?.response);

    //                 dispatch(
    //                     showAlert({
    //                         title: 'create Chat List', message: error?.response?.data?.message ? error?.response?.data?.message : 'Something went wrong!', type: 'Error', status: error?.response?.status,
    //                     }),
    //                 );
    //             } finally {
    //                 dispatch(hideLoading())
    //             }
    //         })
    //     }
    // },

}